import { Component, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

@Component({
  selector: 'app-entry-login',
  templateUrl: './entry-login.component.html',
  styleUrls: ['./entry-login.component.scss'],
  standalone: true,
  imports: [NzCardModule, NzLayoutModule, NzButtonModule],
})
export class EntryLoginComponent {
  private readonly keycloak = inject(Keycloak);

  readonly currentYear = new Date().getFullYear();

  login(): void {
    this.keycloak.login({
      redirectUri: window.location.origin,
    });
  }
}
